<template lang="pug">
	.campaign-wizard
		.floating-panel.flex-row.align-center.justify(:style="{ '--leftOffset': `${offsetLeft}px` }")
			.left
				.prev.nav-item.flex-row.align-center.space(v-if="prevStep", @click="gotoStep(prevStep)")
					fas.icon-left(icon="chevron-left")
					.upper {{getStepName(prevStep)}}
			.flex-col.active-item-holder.center.flex-1.lr-padding
				.font-big.upper.active-item {{getStepName(activeItem)}}
				.description.grey(v-if="!info.isLoading && activeItem && activeItem.hint") {{activeItem.hint()}}
			.right
				template(v-if="!info.isLoading")
					.next.accent.nav-item.flex-row.align-center.space(v-if="nextStep", @click="gotoStep(nextStep)", :class="{ disabled: activeItem.canNext && !activeItem.canNext() }")
						.upper {{getStepName(nextStep)}}
						fas.icon-right(icon="chevron-right")
					.next.finish.nav-item.flex-row.align-center.space(v-else, @click="$emit('finish')", :class="{ disabled: activeItem.canNext && !activeItem.canNext() }")
						.upper {{$tCaption('Finish')}}
						fas.icon-right(icon="check")
			.indicator(:style="{ '--indicator': `${stepPercentage}%`}")
				.progress
</template>

<script>	
	import resizeObserver from 'resize-observer';
	export default {
		translationCategory: 'campaign.Detail',
		name: 'campaign-menu',
		components: {			
		},
		props: ['info', 'items', 'activeItemId'],
		data() {
			return {
				activeItem: this.items[0],
				offsetLeft: 0,
				offsetTop: 0
			};
		},
		computed: {
			prevStep() {
				return this.getStepByDirection(-1);
			},
			nextStep() {
				return this.getStepByDirection(1);
			},
			activeItemIndex() {
				return Math.max(0, this.stepsList.findIndex(f => f?.id === this.activeItem?.id));
			},
			stepsList() {
				const steps = [];
				this.items.map(f => {
					steps.push(f);
					if (f.subItems) {
						steps.push(...f.subItems);
					}
				});

				return steps;
			},
			stepPercentage() {
				return parseInt((this.activeItemIndex + 1) / this.stepsList.length * 100);
			}
		},
		watch: {
			activeItemId(v) {
				if (v != this.activeItem?.id) {
					this.activeItem = this.stepsList.find(f => f.id === v) || this.items[0];
				}
			}
		},
		mounted() {	
			if (__DEBUG__)
				window.campaignWizard = this;
			setImmediate(() => {
				if (this._isDestroyed) return;
				this.gotoStep(this.activeItem);
			});

			this.$unobserve = resizeObserver.observe(this, this.$el, this.calcOffsetLeft);
			this.calcOffsetLeft();
		},
		methods: {
			calcOffsetLeft() {
				const rects = this.$el.getBoundingClientRect();
				this.offsetLeft = rects?.left || 0;
				this.offsetTop = rects?.top || 0;
			},
			getStepByDirection(direction) {				
				return this.stepsList[this.activeItemIndex + direction];
			},
			gotoStep(step) {
				this.$emit('change', step?.id, step);
			},
			getStepName(step) {
				const parent = step?.parent && this.getStepById(step?.parent);
				return parent ? `${parent?.name}: ${step?.name}` : step?.name;
			},
			getStepById(id) {
				return this.stepsList.find(f => f.id === id);
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.campaign-wizard {
		margin-bottom: 50px;

		.floating-panel {
			padding: 10px 15px;
			background: #e6e6e6;
			user-select: none;
			position: fixed;
			width: calc(100vw - var(--leftOffset));
			top: var(--topOffset);
			z-index: 1;
			
			.active-item-holder {
				position: relative;

				> .description {
					position: absolute;
					bottom: -10px;
					left: 21px;
					font-size: 11px;
					width: 95%;
					text-overflow: ellipsis;
					white-space: nowrap;
					overflow: hidden;
					color: $base-accent;
				}
			}
			
			.nav-item {
				padding: 8px 16px;
				border-radius: 4px;
				background: #d8d8d8;
				cursor: pointer;
				color: #333;

				.icon-left {
					padding-right: 0px;
					transition: 0.3s;
				}

				.icon-right {
					padding-left: 0px;
					transition: 0.3s;
				}

				&.accent:not(.disabled) {
					background: $base-accent;
					color: $base-bg;
				}

				&.finish:not(.disabled) {
					background: #4aad3e;
					color: $base-bg;
				}

				&:hover {
					background: $base-accent;
					color: $base-bg;

					.icon-left {
						padding-right: 5px;
					}

					.icon-right {
						padding-left: 5px;
					}
				}
			}

			.indicator {
				width: 100%;
				height: 2px;
				background: #e6e6e6;
				bottom: 0px;
				left: 0px;
				position: absolute;

				> .progress {
					transition: 0.5s;
					height: 100%;
					width: var(--indicator);
					background: $base-accent;
				}
			}
		}
	}
</style>
 